import { spaceQueryPredicates } from '../queries/spaceQueryPredicates.js';
import { spaceQueryKeys } from '../queries/spacesQueryKeys.js';

const syncSpacesAllQuery = (data, queryClient) => {
  for (const space of data) {
    queryClient.setQueriesData({
      predicate: (q) => spaceQueryPredicates.space(q, space.id),
      type: "active"
    }, space);
  }
};
const isSpaceQueryKey = (queryKey) => {
  return Array.isArray(queryKey) && queryKey.length > 0 && spaceQueryKeys.space()[0] === queryKey[0] && queryKey[1] !== void 0 && typeof queryKey[1] === "string";
};
const isSpacesAllQueryKey = (queryKey) => {
  return Array.isArray(queryKey) && queryKey.length > 0 && spaceQueryKeys.spacesAll()[0] === queryKey[0];
};
const syncSpacesQuery = (data, queryKey, queryClient) => {
  if (!Array.isArray(queryKey) || queryKey.length === 0) return;
  if (isSpaceQueryKey(queryKey)) ;
  if (isSpacesAllQueryKey(queryKey)) {
    syncSpacesAllQuery(data, queryClient);
  }
};

export { syncSpacesQuery };
//# sourceMappingURL=spaceSync.js.map
